import React from "react";
import OptionListPicker from "components/OptionListPicker";
import SectionBezel from "components/SectionBezel";
import { useFormikContext } from "formik";
import { EMBED_LAYOUT_OPTIONS } from "utils/constants/embed";
import { STATE_KEYS } from "utils/constants/state";
import { LIST_PICKER_CUSTOM_CLASSES } from "utils/constants/ui";
import get from "lodash/get";

const StyleFields = () => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const allowedTypeProps = {
    value: values.layout,
    name: STATE_KEYS.EMBED.LAYOUT,
    multiselect: false,
    options: EMBED_LAYOUT_OPTIONS,
    onClick: (_, selectedValue) => {
      setFieldValue(STATE_KEYS.EMBED.LAYOUT, selectedValue);
      if (!get(touched, STATE_KEYS.EMBED.LAYOUT)) {
        setFieldTouched(STATE_KEYS.EMBED.LAYOUT, true);
      }
    },
    canUnset: false,
    customClasses: LIST_PICKER_CUSTOM_CLASSES
  };

  return (
    <SectionBezel header="Style" expandable>
      <label className="f5 fw6 db">Layout</label>
      <div className="f6 pt2 lh-copy">Choose your embed layout type.</div>
      <div className="pt3">
        <OptionListPicker {...allowedTypeProps} />
      </div>
    </SectionBezel>
  );
};
export default StyleFields;
